export default "__VITE_ASSET__DvoIXr_O__"